// extracted by mini-css-extract-plugin
var _1 = "StructureSearch_resultItem__9a05a";
var _2 = "StructureSearch_resultsContent__67335";
var _3 = "StructureSearch_searchNum__10868";
var _4 = "StructureSearch_title__39a33";
export { _1 as "resultItem", _2 as "resultsContent", _3 as "searchNum", _4 as "title" }
